import React from 'react';

import {REPORT_TYPE} from '../ToReport'

interface ICommentContext {
  isAuthor: boolean;
  onReport: (data?: {
    type: REPORT_TYPE;
    id: number;
  }) => void;
}

const commentContext = React.createContext({
    isAuthor: false,
    onReport: () => ({}),
} as ICommentContext)

export default commentContext;
